import { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, } from "reactstrap";

interface Props {
    showModal: boolean
}

const KillSessionModal = ({ showModal }: Props) => {
    const [remaining, setRemaining] = useState(10)

    useEffect(() => {
        const interval = setInterval(() => {
            setRemaining(remaining => remaining - 1)
        }, 1000)

        return () => {
            clearInterval(interval)
        }
    })

    setTimeout(() => {
        window.location.reload()
    }, 10000)

    return <>
        <Modal backdrop="static" isOpen={showModal} centered>
            <ModalHeader>Malicious Intrusion detected</ModalHeader>
            <ModalBody>
                Your session will kill in {remaining} s.
            </ModalBody>
        </Modal>
    </>
}

export default KillSessionModal